import { Paragraph } from '@/components/Paragraph';
import { calculateDuration } from '@/utils/calculateDuration';
import { formatDateStringToHourMinutes } from '@/utils/formatDateStringToHourMinutes';

import type { Flight } from '@/types/flights';
import type { ItineraryProduct } from '@/types/products';

interface ProductDayToDayDescriptionProps {
  itineraryProduct: ItineraryProduct;
}

export function ProductDayToDayDescription({ itineraryProduct }: ProductDayToDayDescriptionProps) {
  switch (itineraryProduct.type.toLowerCase()) {
    case 'flight': {
      if (!itineraryProduct.flight) return <Paragraph>Flight information not yet available</Paragraph>;

      if (itineraryProduct.flight.subType === 'indirect' && itineraryProduct.flight.flights) {
        const { flights } = itineraryProduct.flight;

        const getEarliestFlight = flights.reduce(
          (earliestFlight: Flight, flight: Flight) =>
            flight.departureDateTime < earliestFlight.departureDateTime ? flight : earliestFlight,
          flights[0],
        );

        const getLatestFlight = flights.reduce(
          (latestFlight: Flight, flight: Flight) =>
            flight.arrivalDateTime > latestFlight.arrivalDateTime ? flight : latestFlight,
          flights[0],
        );

        if (!getEarliestFlight || !getLatestFlight)
          return <Paragraph>Flight information not yet available bergrepen?</Paragraph>;

        const calculateOverlayDuration = calculateDuration(
          getEarliestFlight?.arrivalDateTime,
          getLatestFlight?.departureDateTime,
        );
        const departureTime = formatDateStringToHourMinutes(getEarliestFlight?.departureDateTime);
        const arrivalTime = formatDateStringToHourMinutes(getLatestFlight?.arrivalDateTime);

        return (
          <Paragraph>
            Departure: {departureTime} - Arrival {arrivalTime}
            <br />
            (Layover at {getEarliestFlight?.arrivalAirport} of {calculateOverlayDuration})
          </Paragraph>
        );
      }

      const departureTime = formatDateStringToHourMinutes(itineraryProduct.flight.departureDateTime);
      const arrivalTime = formatDateStringToHourMinutes(itineraryProduct.flight.arrivalDateTime);

      return (
        <Paragraph>
          Departure: {departureTime} - Arrival {arrivalTime}
        </Paragraph>
      );
    }
    case 'carrental': {
      return (
        <Paragraph>
          Pick-up: {itineraryProduct.startTime} at location: {itineraryProduct.Supplier.location} <br />
          Drop-off: {itineraryProduct.endTime} at location: {itineraryProduct.Supplier.location}
        </Paragraph>
      );
    }

    case 'accommodation': {
      return (
        <Paragraph>
          Check-in: {itineraryProduct.startTime} <br />
          Check-out: {itineraryProduct.endTime}
        </Paragraph>
      );
    }

    case 'ferry':
    case 'transfer': {
      return (
        <Paragraph>
          Departure: {itineraryProduct.startTime} <br />
          Arrival: {itineraryProduct.endTime}
        </Paragraph>
      );
    }

    case 'excursion': {
      return (
        <Paragraph>
          From: {itineraryProduct.startTime} <br />
          Supplier: {itineraryProduct.Supplier.name}
        </Paragraph>
      );
    }

    default:
      return <Paragraph>test</Paragraph>;
  }
}
